<template>
<!-- ==========合同策略组件 ==============-->
<div>
  <!--合同策略-->
  
  <div class="strategyBox">
    <el-form :model="TCF" class="strategy" ref="TCF" label-width="100px">
      <el-row>
        <el-col>
          <el-checkbox label="特陈费" v-model="specialreportFlag" :disabled="isLook" @change="changeSpecial"></el-checkbox>
        </el-col>
      </el-row>
      <el-row class="strategyRow">
        <el-radio-group v-model="specialGroup" style="width:100%;" :disabled="!specialreportFlag || isLook" @change="specialGroupChange">
          <el-col :span="3"><el-radio :label="1">固定费用</el-radio></el-col>
          <el-col :span="5">
            <el-form-item label="金额：" label-width="80px" prop="JE" style="font-size:14px;" ref="TCFJE" :rules="(specialGroup == 1 && specialreportFlag) ? TCFrules.JE:[{required:false}]">
              <el-input-number v-model="TCF.JE" :disabled="isLook || specialGroup != '1'" :controls="false" :min="0" :precision="2"></el-input-number>
              <span class="suffixRight">元</span>
            </el-form-item>
          </el-col>
          <el-col :span="3" :offset="1">
            <el-radio :label="2">按比例收取</el-radio>
          </el-col>
          <el-col :span="5">
            <el-form-item label="计算参数：" prop="JSCS" style="font-size:14px;" ref="TCFJSCS" :rules="(specialGroup == 2 && specialreportFlag) ? TCFrules.JSCS:[{required: false}]">
              <el-select v-model="TCF.JSCS" :disabled="isLook || specialGroup != '2'">
                <el-option
                  v-for="item in calParaList"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                  
                >                 
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="收取比例：" prop="SQBL" ref="TCFSQBL" :rules="(specialGroup == 2 && specialreportFlag) ? TCFrules.SQBL:[{required: false}]">
            <el-input-number v-model="TCF.SQBL" :disabled="isLook || specialGroup != '2'" :controls="false" :min="0" :max="100" :precision="2"></el-input-number>
            <span class="suffixRight">%</span>
          </el-form-item>
          </el-col>
        </el-radio-group>
      </el-row>
    </el-form>
    <el-form :model="YXFFW" class="toolbar strategy" ref="YXFFW" label-width="100px">
      <el-row>
        <el-col>
          <el-checkbox label="营销服务费" v-model="servicefeeFlag" :disabled="isLook" @change="changeServicefee"></el-checkbox>
        </el-col>
      </el-row>
      <el-row class="strategyRow">
        <el-radio-group v-model="servicefeeGroup" style="width:100%;" :disabled="isLook || !servicefeeFlag" @change="servicefeeGroupChange">
          <el-col :span="3"><el-radio :label="1">固定费用</el-radio></el-col>
          <el-col :span="5">
            <el-form-item label="金额：" label-width="80px" prop="JE" style="font-size:14px;" ref="YXFFWJE" :rules="(servicefeeGroup == 1 && servicefeeFlag) ? YXFFWrules.JE:[{required:false}]">
              <el-input-number v-model="YXFFW.JE" :disabled="isLook || servicefeeGroup != '1'" :controls="false" :min="0" :precision="2"></el-input-number>
              <span class="suffixRight">元</span>
            </el-form-item>
          </el-col>
          <el-col :span="3" :offset="1">
            <el-radio :label="2">按比例收取</el-radio>
          </el-col>
          <el-col :span="5">
            <el-form-item label="计算参数：" prop="JSCS" style="font-size:14px;" ref="YXFFWJSCS" :rules="(servicefeeGroup == 2 && servicefeeFlag) ? YXFFWrules.JSCS:[{required: false}]">
              <el-select v-model="YXFFW.JSCS" :disabled="isLook || servicefeeGroup != '2'">
                <el-option
                  v-for="item in calParaList"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                  
                >                 
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="收取比例：" prop="SQBL" ref="YXFFWSQBL" :rules="(servicefeeGroup == 2 && servicefeeFlag) ? YXFFWrules.SQBL:[{required: false}]">
            <el-input-number v-model="YXFFW.SQBL" :disabled="isLook || servicefeeGroup != '2'" :controls="false" :min="0" :max="100" :precision="2"></el-input-number>
            <span class="suffixRight">%</span>
          </el-form-item>
          </el-col>
        </el-radio-group>
      </el-row>
    </el-form>
    <el-form :model="QT" class="toolbar strategy" ref="QT" label-width="100px">
      <el-row>
        <el-col :span="2">
          <el-checkbox label="其他" v-model="otherFlag" :disabled="isLook" @change="changeOther"></el-checkbox>
        </el-col>
        <el-col :span="8">
          <el-form-item label="" prop="EJZB" label-width="0">
            <el-input v-model="QT.EJZB" :disabled="isLook || !otherFlag"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="strategyRow">
        <el-radio-group v-model="otherGroup" style="width:100%;" :disabled="isLook || !otherFlag" @change="otherGroupChange">
          <el-col :span="3"><el-radio :label="1">固定费用</el-radio></el-col>
          <el-col :span="5">
            <el-form-item label="金额：" label-width="80px" prop="JE" style="font-size:14px;" ref="QTJE" :rules="(otherGroup == 1 && otherFlag) ? QTrules.JE:[{required:false}]">
              <el-input-number v-model="QT.JE" :disabled="isLook || otherGroup != '1'" :controls="false" :min="0" :precision="2"></el-input-number>
              <span class="suffixRight">元</span>
            </el-form-item>
          </el-col>
          <el-col :span="3" :offset="1">
            <el-radio :label="2">按比例收取</el-radio>
          </el-col>
          <el-col :span="5">
            <el-form-item label="计算参数：" prop="JSCS" style="font-size:14px;" ref="QTJSCS" :rules="(otherGroup == 2 && otherFlag) ? QTrules.JSCS:[{required: false}]">
              <el-select v-model="QT.JSCS" :disabled="isLook || otherGroup != '2'">
                <el-option
                  v-for="item in calParaList"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                  
                >                 
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            
            <el-form-item label="收取比例：" prop="SQBL" ref="QTSQBL" :rules="(otherGroup == 2 && otherFlag) ? QTrules.SQBL:[{required: false}]">
            <el-input-number v-model="QT.SQBL" :disabled="isLook || otherGroup != '2'" :controls="false" :min="0" :max="100" :precision="2"></el-input-number>
            <span class="suffixRight">%</span>
          </el-form-item>
          </el-col>
        </el-radio-group>
      </el-row>
    </el-form>
  </div>
</div>
</template>
<script>
//跨年合同js
import {GetSelect} from '@/api/getSelect';
export default {
  props:{
    contractLocalid:{
      type:Number,
      required:true
    },
    GETHTCL:{
      type:Object,
      required:true
    },
    isContractTypeLY:{
      type:Boolean,
      required:false
    },
  },
  data(){
    return{
      source: "",       //页面来源
      otherInput: '',  //其它文本内容
      calParaList:[],        //计算参数下拉框枚举   
      otherFlag: false,    //其他是否勾选
      servicefeeFlag: false,    //营销服务费是否勾选
      specialreportFlag: false,  //特陈费是否勾选
      servicefeeGroup: null,   //营销服务费单选组值
      specialGroup: null,   //特陈费单选组值
      otherGroup: null,   //其它单选组值
      TCF:{    //特陈费数据
        JE: undefined,
        JSCS: null,
        SQBL: undefined,
        YJZB: null,
        EJZB: null,
      },
      YXFFW:{    //营销服务费数据
        JE: undefined,
        JSCS: null,
        SQBL: undefined,
        YJZB: null,
        EJZB: null,
      },
      QT:{    //其它数据
        JE: undefined,
        JSCS: null,
        SQBL: undefined,
        YJZB: null,
        EJZB: null,
      },
      TCFrules:{
        JE: [{ required: true, message: '金额必填', trigger: 'blur' },],
        JSCS: [{required: true,message: "请选择计算参数",trigger: 'change'}],
        SQBL: [{ required: true, message: '收取比例必填', trigger: 'blur' },],
      },
      YXFFWrules:{
        JE: [{ required: true, message: '金额必填', trigger: 'blur' },],
        JSCS: [{required: true,message: "请选择计算参数",trigger: 'change'}],
        SQBL: [{ required: true, message: '收取比例必填', trigger: 'blur' },],
      },
      QTrules:{
        JE: [{ required: true, message: '金额必填', trigger: 'blur' },],
        JSCS: [{required: true,message: "请选择计算参数",trigger: 'change'}],
        SQBL: [{ required: true, message: '收取比例必填', trigger: 'blur' },],
      },
      strategyRules:[],
      formArr: ['TCF','YXFFW','QT'],  //待校验的form表单的ref
    }
  },
  methods:{
      checkForm(formName) { //封装验证表单的函数
        var _self=this;
        var result = new Promise(function(resolve, reject) {
          _self.$refs[formName].validate((valid) => {
            if (valid) {
              resolve();
            } else { reject() }
          })
        })
        _self.strategyRules.push(result) //push 得到promise的结果
      },
    validateForm () {
      this.strategyRules = [];
      var _self=this;
      this.formArr.forEach(item => { //根据表单的ref校验
        _self.checkForm(item)
      });
      var flag = null;
      Promise.all(_self.strategyRules).then(value =>{ 
        flag = true;
          this.$emit('getFlag',true)
      }).catch((err) => {
        flag = false;
          this.$emit('getFlag',false)
      });
    },
    //结果返回成功失败类型的接口回调
		resultCallback(info, res) {
			let { code, msg } = res.data;
			if (code == 200 && msg == "success") {
				this.$message({
					type: 'success',
					message: info + '成功!'
				});
			} else {
				this.$message.error(info + '失败!' + msg);
			}
    },
    //保存合同策略2021
		saveStrategy() {
      this.resultArr = [];
      let _self = this;
      this.formArr.forEach(item => { //根据表单的ref校验
        _self.checkForm(item)
      });
      Promise.all(this.resultArr).then(function() { //都通过了
        let params = {
          "contractLocalid": _self.contractLocalid,
          "creator": _self.$getUserId(),
        };
        let HTCL = {};
        if(_self.specialreportFlag || _self.servicefeeFlag || _self.otherFlag){
          params.HTCL = HTCL;
        }
        if(_self.specialreportFlag){
          HTCL.TCF = _self.filterObj(_self.TCF);
        }
        if(_self.servicefeeFlag){
          HTCL.YXFFW = _self.filterObj(_self.YXFFW);
        }
        if(_self.otherFlag){
          HTCL.QT = _self.filterObj(_self.QT);
        }
        _self.$api.contract.saveContractTermItem(params).then(res => {
          _self.resultCallback("保存合同策略", res);
          _self.$emit('getIsPassResult');
        });
      }).catch((err) => {
				_self.$message({
				  type: 'error',
				  message: '保存合同策略失败!'
				});
			});
			
    },
    //checkbox切换
    changeOther(val){
      if(val == false){
        this.otherGroup = null;
        // this.$refs["QT"].resetFields();
        this.QT.JE = undefined;
        this.QT.JSCS = null;
        this.QT.SQBL = undefined;
      }else{
        this.otherGroup = 1;
      } 
    },
    changeSpecial(val){
      if(val == false){
        this.specialGroup = null; 
        // this.$refs["TCF"].resetFields();
        this.TCF.JSCS = null;
        this.TCF.SQBL = undefined;
        this.TCF.JE = undefined;
      }else{
        this.specialGroup = 1;
      } 
    },
    changeServicefee(val){
      if(val == false){
        this.servicefeeGroup = null; 
        // this.$refs["YXFFW"].resetFields();
        this.YXFFW.JE = undefined;
        this.YXFFW.JSCS = null;
        this.YXFFW.SQBL = undefined;
      }else{
        this.servicefeeGroup = 1;
      }
    },
    //转换单选组勾选（存储结构—>展示结构）
    combineRadio(HTCL){
      if(HTCL.QT == undefined ){
        this.otherFlag = false;
      }else{
        this.otherFlag = true;
        this.otherGroup = HTCL.QT.JE == undefined ? 2 : 1;
      }
      if(HTCL.TCF == undefined ){
        this.specialreportFlag = false;
      }else{
        this.specialreportFlag = true;
        this.specialGroup = HTCL.TCF.JE == undefined ? 2 : 1;
      }
      if(HTCL.YXFFW == undefined ){
        this.servicefeeFlag = false;
      }else{
        this.servicefeeFlag = true;
        this.servicefeeGroup = HTCL.YXFFW.JE == undefined ? 2 : 1;
      }
    },
    //其它单选组切换事件
    otherGroupChange(val){
      if(val == 1){ 
        this.QT.JSCS = null;
        this.QT.SQBL = undefined;
      }else{
        this.QT.JE = undefined;
      }
    },
    //营销服务费单选组切换事件
    servicefeeGroupChange(val){
      if(val == 1){ 
        this.YXFFW.JSCS = null;
        this.YXFFW.SQBL = undefined;
      }else{
        this.YXFFW.JE = undefined;

      }
    },
    //特陈费单选组切换事件
    specialGroupChange(val){
      if(val == 1){ 
        this.TCF.JSCS = null;
        this.TCF.SQBL = undefined;
      }else{
        this.TCF.JE = undefined;
      }
    }
  },
  created(){
      let param = JSON.parse(sessionStorage.getItem('param'));
      this.source = param.source || "detail";
      if(this.GETHTCL){
        this.combineRadio(this.GETHTCL);  //返回结构->展示结构
        this.TCF =  Object.assign(this.TCF,this.GETHTCL.TCF);
        this.YXFFW = Object.assign(this.YXFFW,this.GETHTCL.YXFFW);
        this.QT = Object.assign(this.QT,this.GETHTCL.QT);
      }
      GetSelect(this,'contractCalculatedParameters','calParaList'); 
  },
  watch: {  
      TCF:{
          handler:function(nowVal,oldVal){
            this.$emit('getTCF',nowVal)
          },
          deep:true
      },
      YXFFW:{
          handler:function(nowVal,oldVal){
            this.$emit('getYXFFW',nowVal)
          },
          deep:true
      },
      QT:{
          handler:function(nowVal,oldVal){
            this.$emit('getQT',nowVal)
          },
          deep:true
      },
      calParaList: function (val, oldVal) {
        this.calParaList.forEach((value,index,array)=>{
          if(value.value =='J' || value.value =='S' || value.value =='O' || (this.isContractTypeLY &&  value.value == 'M')){
            array.splice(index,1)
          } 
        })
      }
  },
  computed:{
      isLook(){
        return this.source=="detail";
      },
      isEdit(){
        return this.source=="edit";
      },
      isAdd(){
        return this.source=="add";
      },
  }
}
</script>
<style lang="scss">

.strategyBox{
  .strategyRow{
    padding:0 10px;
    margin-bottom: 10px;
    border-bottom:1px solid #EBEEF5;
    &:last-child{
      border:none;
    }
  }
  .el-checkbox__label,.el-radio__label{
    line-height: 30px;
  }
  .el-form-item__label{
    font-size: 14px;
  }
}
  
</style>


// WEBPACK FOOTER //
// src/views/contractmanagement/purchasecontract/add/module/ContractStrategy.vue